/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { isEmpty } from '../helper/is-empty.helper';

export function validateRequired(value: any): boolean {
  return !isEmpty(value);
}
